import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, inject, input } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { ReportFooter } from '@cfp/features-shared/reports/report';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cfp-report-page',
  templateUrl: 'report-page.html',
  styleUrls: ['report-page.scss'],
  imports: [DatePipe, TranslateModule, NgTemplateOutlet, ReportFooter],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.report-page-last]': 'lastPage()'
  }
})
export class ReportPage {
  public readonly portfolioTitle = input.required<string>();
  public readonly lastPage = input<boolean>(false);
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');
  public readonly headerLogo = input<string | undefined>(undefined);
  public readonly chromeFooter = input<TemplateRef<unknown> | undefined>(undefined);

  protected currentDate = new Date();

  protected readonly environment = inject(ENVIRONMENT);

  protected translationKey(suffix: string): string {
    return `${this.translationKeyPrefix()}.${suffix}`;
  }
}
